import React from 'react';

import RelatorioSecoesView from 'components/Relatorios/shared/Aprovacao/RelatorioSecoesView';

/**
 * Aba "Informe Mensal": delega às sub-abas/aprovação genéricas
 * (`RelatorioSecoesView`), configuradas em `helper/Relatorios/Aprovacao/config`.
 */
export default function MensalView() {
  return <RelatorioSecoesView informe="mensal" />;
}
